<template>
    <v-dialog v-model="dialog" width="500" :fullscreen="$vuetify.breakpoint.smAndDown">
        <v-card>
            <v-card-title class="justify-end pb-0">
                <v-btn color="primary" icon @click="dialog = false"><v-icon>fas fa-times</v-icon></v-btn>
            </v-card-title>

            <v-card-title class="justify-center pt-0 text-h4">{{ $t('How it works') }}</v-card-title>

            <qr-code-carousel />

            <v-card-title class="justify-center text-h6">{{ $t('Important!') }}</v-card-title>

            <v-card-text class="text-center">
                <p>{{ $t('the qr-code can only be scanned successfully if the quest is active and live') }}</p>

                <p v-if="getStartDate && getEndDate">{{ getStartDate }} - {{ getEndDate }}</p>

                <v-btn @click="qrCodeDialog = true" block class="my-3" color="primary" depressed large>{{
                    $t('SHOW QR CODE')
                }}</v-btn>

                <v-btn
                    @click="downloadPdf"
                    block
                    color="gray lighten-2"
                    :loading="pdfDownloading"
                    depressed
                    large
                    class="primary--text"
                >
                    {{ $t('Download QR CODE') }}
                </v-btn>

                <a class="hidden" ref="downloadPdf" :href="pdfFile.link" :download="pdfFile.name"></a>
            </v-card-text>

            <v-alert type="error" dismissible v-model="alert">
                {{ $t(error) }}
            </v-alert>

            <v-dialog v-if="qrCodeDialog" v-model="qrCodeDialog" width="500">
                <v-card min-height="500">
                    <v-card-title class="justify-center">
                        <v-spacer />

                        <v-btn color="primary" icon @click="qrCodeDialog = false">
                            <v-icon>fas fa-times</v-icon>
                        </v-btn>
                    </v-card-title>

                    <v-card-text>
                        <v-skeleton-loader v-if="!qrCode" type="image" />
                        <v-skeleton-loader v-if="!qrCode" type="image" />

                        <v-img v-if="qrCode" :src="qrCode" />
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-card>
    </v-dialog>
</template>

<script>
import { Capacitor } from '@capacitor/core';
import { QrCodeModel, QuestPdfModel } from '../models';
import moment from 'moment';

export default {
    props: {
        value: Boolean,
        quest: {
            required: true,
        },
    },
    data() {
        return {
            qrCode: null,
            qrCodeDialog: false,
            pdfFile: {},
            pdfDownloading: false,
            alert: false,
            error: null,
        };
    },
    computed: {
        dialog: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
        getStartDate() {
            let date;

            if (this.quest.activityType && this.quest.activityType.indexname === 'periodic') {
                date = this.getClosestActivityDate();
            } else {
                date = moment(this.quest.endDate.date) - moment() > 0 && moment(this.quest.startDate.date);
            }

            return date && date.set({ h: 0, m: 0 }).format('DD.MM.YYYY, HH:mm');
        },
        getEndDate() {
            let date;

            if (this.quest.activityType && this.quest.activityType.indexname === 'periodic') {
                date = this.getClosestActivityDate();
            } else {
                date = moment(this.quest.endDate.date) - moment() > 0 && moment(this.quest.endDate.date);
            }

            return date && date.set({ h: 23, m: 59 }).format('DD.MM.YYYY, HH:mm');
        },
    },
    methods: {
        async downloadPdf() {
            this.pdfDownloading = true;
            this.alert = false;
            try {
                const { success, fileName, content } = await QuestPdfModel.create({
                    body: { 
                        activityId: this.quest.id,
                        persist: Capacitor.platform !== 'web',
                    },
                });
                if (success === true) {
                    this.pdfFile = {
                        name: fileName,
                    };
                    if (Capacitor.platform === 'web') {
                        const blob = this.b64toBlob(content);
                        this.pdfFile.link = window.URL.createObjectURL(blob);
                    } else {
                        this.pdfFile.link = QuestPdfModel.getDownloadPdfUrl(fileName);
                    }
                    this.$nextTick(() => this.$refs.downloadPdf.click());
                }
            } catch (e) {
                this.error = this.$t('Could not download the file.');
                this.alert = true;
            }
            this.pdfDownloading = false;
        },
        b64toBlob(b64Data, contentType = 'application/pdf', sliceSize = 512) {
            const byteCharacters = atob(b64Data);
            const byteArrays = [];

            for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
                const slice = byteCharacters.slice(offset, offset + sliceSize);

                const byteNumbers = new Array(slice.length);
                for (let i = 0; i < slice.length; i++) {
                    byteNumbers[i] = slice.charCodeAt(i);
                }

                const byteArray = new Uint8Array(byteNumbers);
                byteArrays.push(byteArray);
            }

            return new Blob(byteArrays, { type: contentType });
        },
        getClosestActivityDate() {
            let date;

            (this.quest.activityDates || []).some(activityDate => {
                if (activityDate.isActive && moment(activityDate.date.date) - moment().set({h: 0, m: 0, s: 0, millisecond: 0}) >= 0) {
                    date = moment(activityDate.date.date);
                    return true;
                }
            });

            return date;
        },
    },
    watch: {
        qrCodeDialog(val) {
            if (val && !this.qrCode) {
                QrCodeModel.create({
                    body: {
                        activityId: this.quest.id,
                    },
                }).then(result => {
                    this.qrCode = result.qrCode;
                });
            }
        },
    },
};
</script>
